<template>
    <div>
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->

        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-card class="box">
            <v-toolbar flat dense class="toolbar">
                <v-toolbar-title>Mark Entry Status</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>
            <v-row justify="center" dense>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_ay_data" return-object
                        :items="ay_std_div_list" item-text="ay" label="Select Academic Year" outlined @change="getStd()"
                        @click="putnull" persistent-hint hint="Please Select Academic Year " />
                </v-col>
                <v-col sm="2">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sem" item-value="id"
                        :items="semester_list" item-text="sem" label="Semester" outlined />
                </v-col>
                <v-col sm="2" v-if="std_div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="sel_std_data" return-object
                        :items="std_div_list" item-text="std" label="Standard" outlined @change="getDiv"
                        @click="putnull" persistent-hint hint="Please Select Standard " />
                </v-col>
                <v-col sm="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="div" return-object :items="div_list"
                        item-text="div_name" label="Division" outlined @click="putnull" persistent-hint
                        hint="Please Select Division" />
                </v-col>
                <v-col cols="12" sm="2" md="2" v-if="div_list != null">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete color="#0F2027" dense rounded required v-model="stud_status" :items="status_list"
                        item-text="name" return-object label="Status" outlined persistent-hint hint="Select Status" />
                </v-col>
                <v-col sm="2" v-if="stud_status && div_list!=null && sel_std_data!=null">
                    <v-btn class="mt-6 button" @click="getData" :loading="loader">Fetch</v-btn>
                </v-col>
            </v-row>
            <v-row dense v-if="crs_list != null && component_headers!=''">
                <v-col cols="12" sm="12" md="12">
                    <div id="my-table-id">
                        <v-simple-table class="elevation-1 mytable" dense>
                            <thead>
                                <tr>
                                    <th>Sr. No.</th>
                                    <th>Academic Year</th>
                                    <th>Standard</th>
                                    <th>Division</th>
                                    <th>Course</th>
                                    <th>Teacher</th>
                                    <th>Course Type</th>
                                    <th>Mark Entry Type</th>
                                    <th>Assessment Scheme</th>
                                    <th>Grading Scheme</th>
                                    <th>Student</th>
                                    <th class="" v-for="header in component_headers" :key="header">
                                        <center>{{ header }}</center>
                                    </th>
                                </tr>
                                <tr>
                                    <th class="toolbar" colspan="11"></th>
                                    <th class="toolbar" v-for="header in component_headers" :key="header">
                                        Check / Total Zero / Total
                                    </th>
                                </tr>
                            </thead>
                            <tbody style="overflow-y: scroll;">
                                <tr v-for="crs in crs_list" :key="crs.crs_id">
                                    <td>{{ crs.srno }}</td>
                                    <td>{{ crs.ay }}</td>
                                    <td>{{ crs.std }}</td>
                                    <td>{{ crs.div }}</td>
                                    <td>{{ crs.crs_name }}</td>
                                    <td>{{ crs.inst_name }}</td>
                                    <td>{{ crs.coursetype }}</td>
                                    <td>{{ crs.entry_type }}</td>
                                    <td>{{ crs.courseassessmentscheme }}</td>
                                    <td>{{ crs.gradingscheme }}</td>
                                    <td>
                                        <v-btn class="btn-css btn" @click="get_learners(crs.crs_off_learner)">{{
                                            crs.crs_off_learner.length }}</v-btn>
                                    </td>
                                    <td v-for="header in crs.marks_status" :key="header">
                                        <center>
                                            {{ header.total_check }} / {{header.total_zero}} / <span
                                                class="text-color">{{ header.total_count }}</span>
                                        </center>
                                    </td>
                                </tr>
                            </tbody>
                        </v-simple-table>
                    </div>
                </v-col>
            </v-row>
        </v-card>
        <v-dialog v-model="dialog" persistent max-width="1200px">
            <v-card>
                <v-toolbar class="toolbar" flat dense>
                    <v-toolbar-title>
                        <strong> Course Learners </strong>
                    </v-toolbar-title>
                </v-toolbar>
                <v-col cols="12" sm="12" md="12">
                    <v-card class="box" v-if="learners != ''">
                        <v-row class="p-0 m-0" v-if="learners.length > 0">
                            <v-col class="p-0 m-0" cols="12" sm="6" md="6"> </v-col>
                            <v-col class="p-0 m-0" cols="12" sm="6" md="6">
                                <v-text-field class="search" v-model="search" append-icon="mdi-magnify"
                                    label="Search in table" single-line hide-details></v-text-field>
                            </v-col>
                        </v-row>
                        <v-data-table v-if="learners.length > 0" dense :headers="headers" :items="learners"
                            :search="search" class="elevation-1 mytable"> </v-data-table>
                    </v-card>
                </v-col>
                <v-row justify="center">
                    <v-btn rounded class="button" @click="dialog = false">Close</v-btn>
                </v-row>
            </v-card>
        </v-dialog>
    </div>
    <!-- /. root div -->
</template>
<script>
    import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed


export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            loader: false,
            snackbar_msg: "",
            // extraBreadcrumbItems: [


            // ],
            // breadcrumbClass: "breadcrumb-style1",
            color: "",
            snackbar: false,
            ay_std_div_list: null,
            sel_ay_data: null,
            show_tt: false,
            std_div_list: null,
            sel_std_data: null,
            div_list: null,
            div: null,
            overlay: false,
            fetch_loader: false,
            role: null,
            status_list: [],
            stud_status: null,
            sem_list: null,
            sem: null,
            crs_list: null,
            learners: [],
            dialog: false,
            crs_off_learner: [],
            ass_scheme_deatils_list: [],
            gscheme_list: [],
            ass_type_list: [],
            g_type_list: [],
            component_headers: [],
            sem_list: [],
            headers: [
                {
                    text: "Sr. No.",
                    sortable: false,
                    value: "srno",
                },
                {
                    text: "Academic Year",
                    align: "center",
                    sortable: false,
                    value: "academicyear",
                },
                {
                    text: "Standard",
                    align: "center",
                    sortable: false,
                    value: "std",
                },
                {
                    text: "Division",
                    align: "center",
                    sortable: false,
                    value: "div",
                },
                {
                    text: "PRN No",
                    align: "center",
                    sortable: false,
                    value: "registration_number",
                },
                {
                    text: "Roll No",
                    align: "center",
                    sortable: false,
                    value: "rollno",
                },
                {
                    text: "Name",
                    align: "center",
                    sortable: false,
                    value: "name",
                },
            ],
        }),
        methods: {
            getStd() {
                this.std_div_list = null;
                this.sel_std_data = null;
                this.div_list = null;
                this.div = null;
                this.std_div_list = this.sel_ay_data.std_list;
            },
            getDiv() {
                this.div_list = this.sel_std_data.div_list;
                this.div = this.div_list[0];
                if (this.div_list.length == 0) {
                    alert("No division found!!!");
                    this.div_list = null;
                }
            },
            putnull() {
                this.learner = [];
            },
            getData() {
                this.crs_list = null
                this.component_headers  = []
                const data = {
                    ay: this.sel_ay_data.ay_id,
                    standard: this.sel_std_data.std_id,
                    division: this.div.div_off_id,
                    stud_status: this.stud_status.id,
                    sem: this.sem,
                    role: this.role,
                };
                this.loader = true;
                axios
                    .post("/WWSExamination/getMarkEntryStatus", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.crs_list = res.data.crs_list;
                            this.component_headers = res.data.component_headers;
                            this.loader = false;
                        }
                    })
                    .catch((error) => {
                        this.loader = false;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.loader = false;
                    });
            },
            get_learners(crs_off_learner) {
                const data = {
                    crs_off_learner: crs_off_learner,
                };
                axios
                    .post("/Examination/get_learners_data", data)
                    .then((res) => {
                        this.learners = res.data.learners;
                        this.dialog = true;
                    })
                    .catch((error) => {
                        this.overlay = true;
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {
                        "use strict";
                        this.overlay = false;
                    });
            },
            onLoad() {
                this.role = localStorage.getItem("para_role");
                const data = {
                    role: this.role,
                };
                axios
                    .post("/commonAPI/get_ay_std_div_wws", data)
                    .then((res) => {
                        this.ay_std_div_list = res.data.data;
                        this.sel_ay_data = res.data.curr_ay;
                        this.sem_list = res.data.sem_list;
                          this.semester_list = res.data.semester_list_wws;
                        this.status_list = res.data.status_list;
                        this.stud_status = this.status_list[0];
                        //this.month_list=res.data.month_list
                        //this.year_list=res.data.year_list
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                    })
                    .finally(() => {});
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            onerror(error) {
                let msg = "";
                if (error.response) {
                    msg = "Something went wrong.";
                } else if (error.request) {
                    msg = "Please Select Proper Data.";
                } else {
                    msg = "Un-expected error.";
                }
                this.showSnackbar("error", msg);
            },
        },
        mounted() {
            this.onLoad();
        },
        watch: {},
    };
</script>
<style scoped>
    .table {
        border: none !important;
    }
    input[type="date"] {
        width: 30%;
        display: inline-block;
        padding: 0.3rem;
        border: 1px solid gray;
        border-radius: 30px;
        box-sizing: border-box;
        padding-top: none !important;
        margin-top: none !important;
    }
    .text-color {
        font-weight: bold;
        color: red;
    }
    .scroll {
        overflow-x: scroll;
    }
    .text-color {
        font-weight: bold;
        color: red;
        font-size: small;
    }
    tr,
    td,
    th {
        border: 1px solid #ccc;
        text-align: center;
        font-size: small;
    }
    tr,
    tbody {
        border-bottom: 1px solid #ccc;
        border: 1px solid #ccc;
        font-size: small;
    }
    td {
        margin: 0.3rem !important;
        padding: 0.4rem !important;
        font-size: small;
    }
    @media (min-width: 320px) {
        td,
        th {
            display: table-cell !important;
            font-size: small;
        }
        td + td,
        th + th {
            width: auto;
            font-size: small;
        }
    }
    v-simple-table {
        white-space: nowrap !important;
        text-align: center;
        font-size: small;
    }
    .btn-css {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #fff !important;
        text-decoration: underline;
        color: #0f2027 !important;
        text-align: left;
      }
      
      .btn-css:hover {
        outline: 0 !important;
        outline-offset: 0 !important;
        background-image: none !important;
        -webkit-box-shadow: none !important;
        box-shadow: none !important;
        background-color: #ffff !important;
        color: #0f2027 !important;
        text-decoration: underline;
        text-align: left;
      }
</style>
